import React from 'react';
import { Card, Table } from 'react-bootstrap';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
const NUMBER_OF_ITEMS = 5;
const MyClaims = _ref => {
  let {
    claims,
    accountType,
    loading
  } = _ref;
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  if (!claims) {
    return null;
  }
  const handleViewAllClaims = () => {
    history.push(`${location.pathname}/all_claims/?page=1&query=`);
  };
  return /*#__PURE__*/React.createElement(Card, {
    className: "px-4 py-3 h-100"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "font-weight-bold"
  }, t('my_claims')), claims.length === 0 ? /*#__PURE__*/React.createElement("p", {
    className: "text-center text-secondary"
  }, t('no_claims_assigned')) : /*#__PURE__*/React.createElement(Table, {
    borderless: true,
    style: {
      '--bs-table-striped-bg': 'transparent',
      '--bs-table-bg': 'transparent',
      '--bs-table-accent-bg': 'transparent'
    }
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
    style: {
      background: 'transparent'
    }
  }, /*#__PURE__*/React.createElement("th", null, t('claim')))), /*#__PURE__*/React.createElement("tbody", null, !loading && claims.slice(0, NUMBER_OF_ITEMS).map((claim, index) => {
    return /*#__PURE__*/React.createElement("tr", {
      style: {
        background: 'transparent'
      }
    }, /*#__PURE__*/React.createElement("td", {
      style: {
        background: 'transparent'
      }
    }, /*#__PURE__*/React.createElement(Link, {
      to: `${location.pathname}/companies/${claim.company_id}/${claim.id}/master`
    }, claim.name)));
  }))), /*#__PURE__*/React.createElement("hr", {
    className: "mt-auto"
  }), accountType === 'admin' && /*#__PURE__*/React.createElement(Button, {
    className: "me-auto",
    onClick: handleViewAllClaims,
    variant: "text"
  }, t('view_all_claims')));
};
export default MyClaims;